export default "__VITE_ASSET__DZqnzJYL__"